module.exports = __webpack_public_path__ + "static/media/front_icon.1e61391d.png";